//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div style="width:100%; float:left">
    <div style="float:left">
      <p style="font-size:16px; padding-top:0px;">Медиа</p>
    </div>
    <div style="margin-top:-5px; padding-left:5px; float:left">
      <Button type="text" size="small" style="border-radius:3px; margin-bottom:5px; padding-top:5px;" @click="reloadOnClick">
        <Icon type="ios-loop" size="18"></Icon>
      </Button>
    </div>
  </div>

  <div v-if="commonData.isLoaded == false">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="dataIsLoaded == false">
    Подождите, загружаются данные по банкам
  </div>
  <div v-else style="width:100%; float:left">

   <div :style="expandTable == true ? 'width:100%' : 'width:calc(100% - 500px)'" style="height:100%; padding-right:0px; float:left;">

    <div style="width:50px; padding-top:11px; padding-bottom:0px; display:inline-block; float:left;"><span>Фильтр</span></div>
    <div style="padding-bottom:12px; display:inline-block; width:300px">
      <Input v-model="filterValue" size="large" style="width:100%" v-on:on-change="filterValueOnChange"/>
    </div>

    <div style="float2:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="ghost" style="border-radius:3px; height:36px; margin-bottom:0px;" size="large" :disabled="(editingDataRow != null) && (editingDataRow.val.id == null)" @click="newEditingDataRowOnClick">+</Button>
    </div>

    <div v-if="filteredRecords.length > 0">
     <div v-for="(itemData, keyData) in filteredRecords" :key="keyData" style="width:300px; height:335px; padding:5px; margin:0 10px 10px 0; border-radius:10px; float:left;"
      :style="{border: isRowSelected(itemData) == true ? '2px solid #a0a7ff' : '2px solid #aaa',
              color: isRowSelected(itemData) == true ? '#fff' : '#fff',
              background: isRowSelected(itemData) === true ? '#a0a7ff' : '#a9acb7'}"
      @click="dataRowOnSelect(itemData)"> <!--#778087-->

      <div :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+itemData.val.id+')'}" class="list-image-thumb">&nbsp</div>
      <div style="width:100%; margin:10px 0 0px 0; padding:0px; float:left; text-align:center;">
        <Icon type="image" style="font-size:19px"/>
        <span style="font-size:18px; margin-left:10px;"><b>{{itemData.val.name}}&nbsp;</b></span>
      </div>

     </div>

     <div v-if="filteredRecords.length == numOfItemsToShowWithEmptyFilter" style="clear:left">
       * Список не полный, еще много всего найдено. Используйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
     </div>
    </div>

    <div v-else>
      * Ничего не найдено. Скорректируйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
    </div>

   </div>

   <div style="width:500px; padding: 44px 0px 10px 20px; border-left:1px solid #ccc; position:fixed; top:100px; left:calc(100vw - 535px); z-index:1001; float:left;" :class="(expandTable == true) ? 'hidden' : ''">

     <div v-if="editingDataRow != null">

        <div style="width:100%; padding-top:5px; padding-bottom:20px; display:inline-block; float:left;">
          <span v-if="editingDataRow.val.id != null"><b>РЕДАКТИРОВАНИЕ :</b></span>
          <span v-else><b>НОВЫЙ ФАЙЛ :</b></span>
        </div>

        <div id="editingdatarowimage" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.id+')'}" class="editingdatarow-image">&nbsp</div>
        <div style="width:100%; padding:5px 0 15px 0; text-align:center; clear:left;">
          <input type="file" ref="editingDataRowFileRef" @change="uploadingFileOnChange()" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef.click()" style="padding:5px 15px 5px 15px; font-size:15px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:5px 5px 5px 5px;">Загрузить файл</button>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Имя</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Input v-model="editingDataRow.val.name" style="width:100%"></Input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Тип</span></div>
        <div style="height:28px; padding:5px 0 5px 0; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{editingDataRow.val.extension}}
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Ссылка</span></div>
        <div style="height:28px; padding:5px 0 5px 0; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{appSettings.server.host + appSettings.server.fileEntityGetFile + editingDataRow.val.id}}
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Идентификатор</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{editingDataRow.val.id}}&nbsp;
        </div>

        <div style="padding: 35px 0px 5px 0px;">
          <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveEditingDataRowOnClick">Сохранить</Button>
          <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelEditingDataRowOnClick">Отменить</Button>
          <Button type="ghost" style="float:right; border-radius:3px; margin-bottom:10px; padding-top:5px; color:#d7d7d7;" :class="editingDataRow.val.id == null ? 'hidden' : ''" @click="deleteEditingDataRowOnClick">
            <Icon type="trash-b" size="18"></Icon>
          </Button>
        </div>

     </div>

     <!--div v-else>
       * Выберите запись для просмотра или редактирования
       <br><br><br>
     </div-->

   </div>

  </div>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import arrayTools from '@/technical/arrayTools/arrayTools'

// import serverData from '@/store/serverData'

export default {
  components: { },
  data () {
    return {
      data: [], // list of component records
      filteredRecords: [],

      // UI FIELDS
      dataIsLoaded: false,
      numOfItemsToShowWithEmptyFilter: 50,

      filterValue: '',

      expandTable: true,

      loadingSpinner: false,

      selectedDataRow: null,
      editingDataRow: null,
      editingDataRowFile: ''
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData'
    ])
  },
  created: function () {
    // var thisRef = this
    // this.data = serverData.finixBanks // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event FinixBanksChanged
    // thisRef.dataIsLoaded = true // !!! т к это CommonData то когда commonData.isLoaded == true то сразу ставим и dataIsLoaded = true

    /* serverData.finixBanksOnDestroyDelegates.push(this.deleteDataRecDelegate)

    serverData.eventsBus.$on('finixBanksChanged', (data) => {
      // console.log('on finixBanksChanged')
      // console.log(data)
      // if (this.editingDataRec.val.id === data.record.id) {
      //  this.editingDataRec.val = Object.assign({}, data.record)
      // }
      if (data.method === 'read') thisRef.dataIsLoaded = true
      thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    })

    // если это не перезагрузка данной страницы то serverData уже давно бы был и тут бы мы строили список наших отображаемых данных
    // но это только для CommonData, т е тех что загружаются в приложени по умолчанию. а наши данные надо тут указать что грузим
    thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    // serverData.finixBanksReload(function () {}) // вместо callback функционал сработает через serverData.eventsBus.$on('finixBanksChanged')
    */
    this.reloadOnClick()
  },
  methods: {
    ...mapMutations([
      'commonDataIsLoadedSet'
    ]),
    uploadingFileOnChange () {
      // забираем себе объект готового к загрузке файла
      this.editingDataRowFile = this.$refs.editingDataRowFileRef.files[0]

      if (this.editingDataRowFile) {
        // меняем название fileEntity
        if (this.editingDataRow.val.name === '') this.editingDataRow.val.name = this.editingDataRowFile.name
        // меняем картинку редактируемого fileEntity
        var reader = new FileReader()
        reader.onload = function (e) {
          var el = document.getElementById('editingdatarowimage')
          el.style.backgroundImage = 'url(' + e.target.result + ')'
        }
        reader.readAsDataURL(this.editingDataRowFile)
      }
    },

    reloadOnClick () {
      var thisRef = this
      // thisRef.data = [] // трется внутри serverData.reload
      thisRef.dataIsLoaded = false

      // serverData.finixBanksReload(function (err) {
        // if (err) return serverErrorHandling(err, thisRef)
        // вместо этих строк работает serverData.eventsBus.$on('finixBanksChanged', (data))
        // thisRef.data = serverData.finixBanks // data так и смотрела на serverData которые не перезаписывались а стирались и добавлялись
        // thisRef.filterValueOnChange()
      // })

      // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
      var cmsMedias = []
      http.get(thisRef.appSettings.server.host + thisRef.appSettings.server.fileEntityResource + thisRef.appSettings.server.cmsMediaFilesCriteria)
      .then(function (response) {
        if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
        // users[0] = {Name: '- Выберите автора -', id: 0}
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          var oneCMSMediaResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.fileEntityResource)
          oneCMSMediaResource.val = response.data[itemIndx]
          cmsMedias.push(oneCMSMediaResource)
        }
        thisRef.data = cmsMedias
        thisRef.filterValueOnChange()
        thisRef.dataIsLoaded = true
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },

    filterValueOnChange () {
      this.filteredRecords.splice(0, this.filteredRecords.length)

      if (this.data.length === 0) return

      for (let i = this.data.length - 1; i >= 0; i--) {
        if (this.filterValue.length < 3) {
          if (this.filteredRecords.length < this.numOfItemsToShowWithEmptyFilter) this.filteredRecords.push(this.data[i])
          continue
        }

        if (this.data[i].val.id.toString().indexOf(this.filterValue) !== -1) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        var filterValueLowerCase = this.filterValue.toLowerCase()
        if ((this.data[i].val.name != null) && (this.data[i].val.name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.extension != null) && (this.data[i].val.extension.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
      }

      arrayTools.sort(this.filteredRecords, function (a, b) {
        return a.val.id < b.val.id
      })
    },

    newEditingDataRowOnClick () {
      var newEntity = restResource(this.appSettings.server.host + this.appSettings.server.fileEntityResource)
      newEntity.val = {}
      newEntity.val.name = ''
      newEntity.val.extension = ''
      newEntity.val.container = 'cmsMedia'

      this.selectedDataRow = null
      this.editingDataRowFile = ''
      this.editingDataRow = Object.assign({}, newEntity)
      this.editingDataRow.val = Object.assign({}, newEntity.val)

      this.expandTable = false // to show newEntity editing
    },

    cancelEditingDataRowOnClick () {
      this.selectedDataRow = null
      this.editingDataRowFile = ''
      this.editingDataRow = null
      this.expandTable = true
    },

    saveEditingDataRowOnClick () {
      // if (this.editingDataRow.val.name === '') return this.$message.error('Введите название')

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      // если есть файл для загрузки (при create или uodate), то обновляем запись через storeFileByFormData. тут же считаются и обновятся
      let formData = new FormData()
      if (this.editingDataRow.val.id != null) formData.append('id', this.editingDataRow.val.id)
      formData.append('name', this.editingDataRow.val.name)
      formData.append('container', 'cmsMedia')
      if (this.editingDataRowFile !== '') formData.append('_data', this.editingDataRowFile)

      http.post(this.appSettings.server.host + this.appSettings.server.fileEntityResource + '/storeFileByFormData/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(function () {
        thisRef.loadingSpinner = false
        loading.close()

        thisRef.selectedDataRow = null
        thisRef.editingDataRowFile = '' // чтобы при следующей загрузке файл не был выбран; или thisRef.editingDataRowFile = []; если multiple files
        thisRef.editingDataRow = null
        thisRef.expandTable = true

        thisRef.reloadOnClick()
      })
      .catch(function (err) {
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(err, thisRef)
      })
    },

    deleteEditingDataRowOnClick () {
      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      thisRef.editingDataRow.delete()
      .then(function (response) {
        thisRef.loadingSpinner = false
        loading.close()

        thisRef.selectedDataRow = null
        thisRef.editingDataRowFile = ''
        thisRef.editingDataRow = null
        thisRef.expandTable = true

        thisRef.reloadOnClick()
      })
      .catch(function (error) {
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(error, thisRef)
      })
    },

    deleteDataRecDelegate (deletedRecord, cb) {
      /* var thisRef = this
      if ((thisRef.editingDataRec != null) && (deletedRecord.id === thisRef.editingDataRec.val.id)) {
        thisRef.editingDataRec = null
      } */
      return cb()
    },

    dataRowOnSelect (value) {
      this.selectedDataRow = value
      this.editingDataRowFile = ''
      this.editingDataRow = Object.assign({}, value)
      this.editingDataRow.val = Object.assign({}, value.val)
      this.expandTable = false
    },

    isRowSelected (row) {
      if (this.selectedDataRow == null) return false
      if (row.val.id === this.selectedDataRow.val.id) return true
      else return false
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.top-panel-expand-table-button {
  margin: 0px;
  pading: 0px;
  font-size: 17px;
  color: #5a5a5a;
  cursor: pointer;
}
.top-panel-expand-table-button:hover {
  color: #000;
}
.datalist{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.datalist-scroll {
  overflow-y: scroll;   /* надо чтобы работал scroll для mainMenu */
  height: calc(100vh - 200px);
  /* width: 257px; /* минимум на 17 пикселей больше чем mainmenu-panel.width, ща сделал на 50 больше */
}
hr {
  /*border: none; /* Убираем границу для браузера Firefox */
  /*color: #ccc; /* Цвет линии для остальных браузеров */
  /*background-color: #ccc; /* Цвет линии для браузера Firefox и Opera */
  /*height: 1px; /* Толщина линии */
  margin: 10px 0 15px 0;
  margin: 50px;
}
.list-image-thumb {
  height: calc(100% - 35px);
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.editingdatarow-image {
  width: 100%;
  height: 450px;
  margin: 0 0 10px 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  float: left;
}
.input_file_hidden{
  position: absolute;
  top: -500px;
}
</style>

</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.incomesAndExpensesTextarea textarea.ivu-input {
  font-size: 12px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Media.vue?b13d8ea4